import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { AiFillEye, AiFillGithub } from "react-icons/ai";

import { client, urlFor } from "../../client";

import "./Work.scss";
import AppWrap from "../../wrapper/AppWrap/AppWrap";

const Work = () => {
  // For Get Data from Dashboard
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);

  // For Filter Component
  const [_tags, setTags] = useState(new Set());
  const [activeFilter, setActiveFilter] = useState("all");

  // Animte Content Portfolio
  const [animateCards, setAnimateCards] = useState({
    y: [100, 0],
    opacity: [0, 1],
  });

  useEffect(() => {
    const query = '*[_type=="works"]';
    client.fetch(query).then((res) => {
      for (let obj of res) {
        // const lower_tags = obj.tags.map((tag) => tag.toLowerCase());
        // _tags.add(...lower_tags);

        for (let tag of obj.tags) _tags.add(tag);
        // add() accept one param only
      }

      // console.log(_tags);
      // console.log(res);
      setTags([..._tags]);
      setData(res);
      setFilteredData(res);
    });
  }, []);

  const handleActiveFilter = (subject) => {
    setActiveFilter(subject);
    setAnimateCards({
      y: [0, 100],
      opacity: [1, 0],
    });

    setTimeout((_) => {
      if (subject !== "all") {
        setFilteredData(data.filter((itm) => itm.tags.includes(subject)));
      } else {
        setFilteredData(data);
      }

      setAnimateCards({
        y: [100, 0],
        opacity: [0, 1],
      });
    }, 500);
  };

  return (
    <div className="app__work">
      <div className="head-text">
        Explore our <span>creative apps</span>
      </div>

      <div className="app__work-filter app__flex">
        {["all", ..._tags].map((work) => (
          <div
            key={`work-${work}`}
            className={`${activeFilter === work && "active"}`}
            onClick={() => handleActiveFilter(work)}
          >
            {work}
          </div>
        ))}
      </div>

      <motion.div className="app__work-portfolio" animate={animateCards}>
        {filteredData.map((work) => (
          <div
            key={`portfolio-${work.title}`}
            className="work-portfolio app__flex"
          >
            <div className="portfolio-img app__flex">
              <img src={urlFor(work.imgUrl)} />
              <motion.div
                whileHover={{ opacity: [0, 1] }}
                transition={{
                  duration: 0.5,
                  ease: "easeInOut",
                  staggerChildren: 0.5,
                }}
                className="portfolio-overlay app__flex"
              >
                <a href={work.projectLink} target="_blank" rel="noreferrer">
                  <motion.div
                    whileInView={{ scale: [0, 1] }}
                    whileHover={{ scale: [1, 0.9] }}
                    transition={{ duration: 0.25 }}
                    className="app__flex"
                  >
                    <AiFillEye />
                  </motion.div>
                </a>
                <a href={work.codeLink} target="_blank" rel="noreferrer">
                  <motion.div
                    whileInView={{ scale: [0, 1] }}
                    whileHover={{ scale: [1, 0.9] }}
                    transition={{ duration: 0.25 }}
                    className="app__flex"
                  >
                    <AiFillGithub />
                  </motion.div>
                </a>
              </motion.div>
            </div>
            <div className="portfolio-info">
              <h4 className="portfolio-title">{work.title}</h4>
              <p className="portfolio-desc">{work.description}</p>
              <p className="tag">
                {work.tags.length >= 2
                  ? `${work.tags[0]}, more+`
                  : work.tags[0]}
              </p>
            </div>
          </div>
        ))}
      </motion.div>
    </div>
  );
};

export default AppWrap(Work, "work");
